import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const CenteralizedServiceProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();
    
    const centeralizedServices = useCallback(async (props) => {
        await execute({ scope: 'centralizedServices', url: `CentralizedServices/Stats`, method: 'GET', secure: true });
    }, [execute]);

    const value = { centeralizedServices, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useCenteralizedServiceStore = () => React.useContext(Context);
